import React, { Component } from 'react';
import { Button, Modal} from 'react-bootstrap';

import Brick from './Brick'


class BrickArea extends Component {

  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };

    this.handleClose = this.handleClose.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }  
  handleClose() {
    this.setState({ modal: false });
  }
  handleShow() {
    this.setState({ modal: true });
  }

  brickClicked = (clickedBrick) => {
    if (this.props.selectedBrickIndexes.length === (this.props.numberOfBricksAllowedToBeSelected-1) && !this.props.selectedBrickIndexes.includes(this.props.bricks.findIndex((brick)=>brick.id === clickedBrick.id)))
    {
      //close the modal because the last brick has been selected
      this.setState({
        modal: false
      });
    }
    this.props.onBrickClicked(clickedBrick);
  }

  render() {
    return (
      <div>
        <div className="brickArea hidden-xs">
          <h3>1.) Choose Up to {this.props.numberOfBricksAllowedToBeSelected} Colors</h3>

          {this.props.bricks.map(function (brick, index) {
            return <Brick {...brick} key={index} onBrickClick={this.brickClicked} />
          }, this)}
        </div>
        <div className="visible-xs">
        <div className="static-modal">
          <Button bsStyle="danger" onClick={this.handleShow}>Choose Up to {this.props.numberOfBricksAllowedToBeSelected} Colors</Button>
          <Modal show={this.state.modal} className='modal-lg' onHide={this.handleClose}>
            <Modal.Header closeButton>Brick Colors</Modal.Header>
            <Modal.Body>
              {this.props.bricks.map(function (brick, index) {
                return <Brick {...brick} key={index} onBrickClick={this.brickClicked} />
              }, this)}
            </Modal.Body>
            <Modal.Footer>
              <Button color="primary" onClick={this.handleClose}>Ok</Button>
            </Modal.Footer>
          </Modal>
          </div>
        </div>

      </div>



    );
  }
}

export default BrickArea;
